module.exports = __webpack_public_path__ + "static/media/havana-1.321f21b6.jpg";